import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Inject, Output } from '@angular/core';
import { MatLegacyDialogModule, MatLegacyDialogRef, MAT_LEGACY_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { DragDropModule } from '@angular/cdk/drag-drop';

import { ButtonComponent, Color, IconComponent, Variant } from '@mode/capra';
import { DialogHeaderComponent } from '../dialog/header/dialog-header.component';

export interface ConfirmDialogData {
  dialogTitle?: string;
  dialogText?: string;
  confirmText?: string;
  cancelText?: string;
  icon?: string;
  confirmButtonColor?: Color;
  confirmButtonType?: Variant;
  confirmAction?: () => void;
  cancelAction?: () => void;
}

@Component({
  standalone: true,
  selector: 'mode-confirm-dialog',
  imports: [ButtonComponent, CommonModule, DialogHeaderComponent, DragDropModule, IconComponent, MatLegacyDialogModule],
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConfirmDialogComponent {
  @Output() confirm = new EventEmitter();
  @Output() cancel = new EventEmitter();

  constructor(
    @Inject(MAT_LEGACY_DIALOG_DATA) public data: ConfirmDialogData = { confirmButtonType: 'secondary' },
    public dialogRef: MatLegacyDialogRef<ConfirmDialogComponent>
  ) {
    data.confirmButtonType = data.confirmButtonType ?? 'secondary';
  }

  onConfirm(): void {
    this.confirm.emit();
    this.dialogRef.close();
  }

  onCancel(): void {
    this.cancel.emit();
    this.dialogRef.close();
  }
}
